import { createSelector } from '@reduxjs/toolkit';
import { CirculationsState } from './types';
import { RootState } from '../root-reducer';

import { stationsSelector } from '../stations/selectors';

export const rootSelector = (state: RootState): CirculationsState => state.Circulations;

export const statusSelector = createSelector(rootSelector, (state) => state.status);
export const errorSelector = createSelector(rootSelector, (state) => state.error);
export const refreshedDateSelector = createSelector(rootSelector, (state) => state.refreshedDate);
/** need stations to be fetched, if you want full station names on segments */
export const dataSelector = createSelector(rootSelector, stationsSelector, ({ data: circulations }, stations) => {
  return {
    ...circulations,
    result: circulations?.result?.map((service) => ({
      ...service,
      segments: service.segments.map((segment) => ({
        ...segment,
        departureStationFullName: stations
          ? stations.find((station) => station.uicStationCode === segment.departureStation)?.name
          : undefined,
        arrivalStationFullName: stations
          ? stations.find((station) => station.uicStationCode === segment.arrivalStation)?.name
          : undefined,
      })),
    })),
  };
});

export const shoudUsePersistedCirculationsFiltersSelector = createSelector(
  rootSelector,
  (dataFilter) => dataFilter.shoudUsePersistedCirculationsFilters
);

export const persistedCirculationsFiltersSelector = createSelector(
  rootSelector,
  (dataFilter) => dataFilter.persistedCirculationsFilters
);
